var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconClockWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r8vcls87ua)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 13C2.925 13 0 10.075 0 6.5S2.925 0 6.5 0 13 2.925 13 6.5 10.075 13 6.5 13zm0-11.917c-2.98 0-5.417 2.438-5.417 5.417 0 2.98 2.438 5.417 5.417 5.417 2.98 0 5.417-2.438 5.417-5.417 0-2.98-2.438-5.417-5.417-5.417z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 7.042c-.325 0-.542-.217-.542-.542V2.708c0-.325.217-.541.542-.541.325 0 .542.216.542.541V6.5c0 .325-.217.542-.542.542z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.667 9.208a.492.492 0 0 1-.38-.162L6.122 6.879a.524.524 0 0 1 0-.758.524.524 0 0 1 .758 0l2.167 2.167a.524.524 0 0 1 0 .758.492.492 0 0 1-.38.162z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "r8vcls87ua"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h13v13H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClockWhite);
export default __webpack_public_path__ + "static/media/icon-clock-white.4ea9fd67c905bc2d1eedb96d5dd0fedb.svg";
export { ForwardRef as ReactComponent };